import {
  Qualification,
  QualificationHttp,
  QualificationWizard,
  TELEOPERATOR_PROFESSION_SLUGS,
} from '@data/models/qualification.interface';

export const toQualification = (
  qualification: Partial<QualificationHttp>,
): Qualification => {
  return {
    id: qualification.id || '',
    label: qualification.attributes?.label || '',
    code: qualification.attributes?.code || '',
    isTeleoperator: TELEOPERATOR_PROFESSION_SLUGS.includes(
      qualification.attributes?.code || '',
    ),
  };
};

export const toQualificationWizard = (
  qualification: Partial<Qualification>,
): QualificationWizard => {
  return {
    type: 'qualification_repositories',
    id: qualification.id || '',
    attributes: {
      label: qualification.label || '',
      code: qualification.code || '',
    },
  };
};
